<template>
  <div class="carAppointmentContainer">
    <div class="carAppointmentContent" v-for="(item,index) in list" :key="index">
      <div class="currentTime">{{ item.time }}</div>
      <div class="appointmentContent">
        <div class="appointmentItems" v-for="(i,$index) in item.content" :key="$index">
          <div class="appointmentTitle">{{i.title}}:</div>
          <div class="appointmentMain">
            {{i.lable}}
          </div>
          <div class="line"></div>
          <div class="checkDetail">
            <div @click="checkDetail(i)">查看详情<van-icon name="arrow" /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "messagePush",
  data() {
    return {
      list: [
        {
          time: '星期三 10：06',
          
          content: [
            {
              title: '预定成功通知',
              lable:' 您的公务车申请已经预定成功，分配粤L720w2进行服务，若有疑问请及时与厂务沟通'
            },
            {
              title: '同行通知',
              lable:' 您的公务车申请已经预定成功，分配粤L720w2进行服务，若有疑问请及时与厂务沟通'
            },
          ]
        },
        {
          time: '星期四 10：06',
          
          content: [
            {
              title: '同行通知',
              lable:' 您的公务车申请已经预定成功，分配粤L720w2进行服务，若有疑问请及时与厂务沟通'
            },
            {
              title: '出发通知',
              lable:' 您的公务车申请已经预定成功，分配粤L720w2进行服务，若有疑问请及时与厂务沟通'
            },
          ]
        },
      ]
    }
  },
  methods: {
    // 点击查看详情
    checkDetail(i) {
      console.log(i);
      if (i.title==='预定成功通知') {
        this.$router.push({
          path: '/car/official/index',
          // query: {
          //   name:''
          // }
        })
      } else if (i.title==='同行通知') {
        this.$router.push({
          path: '/car/official/index',
          // query: {
          //   name:''
          // }
        })
      } else if (i.title==='出发通知') {
        this.$router.push({
          path: '/car/facility/useCarApply',
          query: {
            name:2
          }
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .carAppointmentContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .carAppointmentContainer {
    width: 276px * $zoom;
  }
}
.carAppointmentContainer {
  width: 100%;
  .carAppointmentContent {
    padding: 0 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .currentTime {
      height: 1.3125rem;
      line-height: 1.3125rem;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #969b9e;
      text-align: center;
      // padding: .9375rem 0;
    }
    .appointmentContent {
      .appointmentItems {
        background-color: #fff;
        padding: 20px;
        border-radius: 18px;
        margin-bottom: 27px;
        .appointmentTitle {
          font-size: 29px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #282b32;
        }
        .appointmentMain {
          font-size: 26px;
          text-indent: 1em;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #969b9e;
          margin: 19px 0 36px 0;
        }
        .line {
          width: 100%;
          height: 1px;
          background-color:  #F1F1F1;
          margin: 25px 0;
        }
        .checkDetail {
          text-align: right;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #969b9e;
        }
      }
    }
  }
}
</style>
